import React, { FC } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

import { Element, width, scale as initialScale, notchTop } from '@components/frame';
import { isAndroid, navigateTo } from '@helpers';
import Header from '@components/common/AnimatedHeader';

import { font as initialFont } from '@styles/fonts';

import { ImageHandlingHeaderProps } from './Header';
import { useManageImageHandlingHeaderMobile } from './hooks/useManageImageHandlingHeaderMobile';

let counter = 1;
let timeOut: NodeJS.Timeout | null = null;

export interface ImageHandlingHeaderMobileProps
  extends Pick<ImageHandlingHeaderProps, 'setMode' | 'C' | 'images' | 'selectedIndex' | 'imageContextForAdding' | 'scale' | 'font'> {
  showAddImageModal: boolean;
  isSingleImage: boolean;
  onBackButtonPress: () => void;
}

const ImageHandlingHeaderMobile: FC<ImageHandlingHeaderMobileProps> = ({
  C,
  images,
  selectedIndex,
  showAddImageModal,
  setMode,
  isSingleImage,
  imageContextForAdding,
  onBackButtonPress,
  scale = initialScale,
  font = initialFont,
}) => {
  const { actions, img } = useManageImageHandlingHeaderMobile({
    C,
    imageContextForAdding,
    images,
    isSingleImage,
    selectedIndex,
    setMode,
    showAddImageModal,
    font,
    scale,
    onBackButtonPress,
  });

  const TextComponent = () => {
    return (
      <Element
        scale={scale}
        {...{
          config: { width: '100%' },
        }}
      >
        {/* <TouchableOpacity
          activeOpacity={1}
          onPress={() => {
            if (counter >= 5) {
              counter = 1;
              navigateTo('ImageSystemInfo', { id: img?.documentId });
              return;
            }
            counter += 1;

            if (timeOut) {
              clearTimeout(timeOut);
            }

            timeOut = setTimeout(() => {
              counter = 1;
            }, 2000);
          }}
        > */}
        <Element
          scale={scale}
          {...{
            config: {
              position: {
                top: -11,
                left: 0,
              },
              width: width / 2,
              horizontalCenter: 0,
              justifyContent: 'center',
            },
          }}
        >
          <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary'), textAlign: 'center' }]} numberOfLines={1} ellipsizeMode="middle">
            {img.fileName}
          </Text>
        </Element>
        <Element
          scale={scale}
          {...{
            config: {
              position: {
                top: 7,
                left: 0,
              },
              width: '100%',
              justifyContent: 'center',
            },
          }}
        >
          <Text style={[font['Caption 2'], { color: C('Label/Light/Secondary'), textAlign: 'center' }]} numberOfLines={1}>
            {img.modifiedOn}
          </Text>
        </Element>
        {/* </TouchableOpacity> */}
      </Element>
    );
  };

  return (
    <View style={{ width: '100%', top: isAndroid ? notchTop : 0, zIndex: 1000 }}>
      <Header
        {...{
          animated: false,
          C,
          TextComponent: TextComponent,
          actions,
        }}
      />
    </View>
  );
};

export default ImageHandlingHeaderMobile;
